/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Button, Card, CardBody, CardFooter, CardHeader, Input } from 'reactstrap';
import QuestionHeader from '../QuestionHeader';
import './styles.css';

const random = (arrayIndexFillIn, randomFillIn, length, count) => {
  if (count === randomFillIn) {
    return arrayIndexFillIn;
  }
  const element = Math.floor(Math.random() * length);
  if (!arrayIndexFillIn.includes(element)) {
    arrayIndexFillIn.push(element);
    return random(arrayIndexFillIn, randomFillIn, length, count + 1);
  }
  return random(arrayIndexFillIn, randomFillIn, length, count);
};

function randomIndexFillIn(question, settings) {
  // số từ random mặc định là 2
  let randomFillIn = 2;
  if (settings) {
    const pureSettings = typeof settings === 'string' ? JSON.parse(settings) : settings;
    const { randomNumbers } = pureSettings.answers;
    randomFillIn = randomNumbers > question.length ? question.length : randomNumbers;
  }
  // Vị trí ngẫu nhiên được chuyển thành input
  let arrayIndexFillIn = [];
  if (question.includes('_')) {
    question.split('').forEach((element, index) => {
      if (element === '_') {
        arrayIndexFillIn.push(index);
      }
    });
  } else {
    arrayIndexFillIn = random(arrayIndexFillIn, randomFillIn, question.length, 0);
  }
  arrayIndexFillIn = arrayIndexFillIn.sort((a, b) => a - b);
  return arrayIndexFillIn;
}

const FillLetterInTheBlank = ({ ExplainText, data, userData, questionIndex }) => {
  const [state, setState] = React.useState({
    answers: [],
    isSubmit: false,
    randomIndex: randomIndexFillIn(data.question, data?.settings, data?.answers),
    userData: '',
    correctAnswers: [],
  });

  React.useEffect(() => {
    const { question, answers } = data;
    let answerArray = answers.split('');
    question.split('').forEach((item, index) => {
      if (item !== '_') {
        answerArray[index] = undefined;
      }
    });
    answerArray = answerArray
      .map((item, index) => { return { id: index, answer: item }; })
      .filter(x => x.answer !== undefined);

    setState((prevState) => ({ ...prevState, answers: userData?.answers ?? [], correctAnswers: answerArray }));
  }, [data, userData]);

  const ref = React.useRef();
  ref.current = new Audio();
  const playAudio = React.useCallback((audioUrl) => {
    ref.current.src = audioUrl;
    ref.current.play();
  }, []);

  const onHandleInput = React.useCallback(
    (item, index) => {
      let { answers } = state;
      const i = answers.findIndex((x) => x.id === index);
      if (i > -1) {
        answers[i].answer = item;
      } else {
        answers.push({ id: index, answer: item });
      }
      answers = answers.sort((a, b) => a.id - b.id);
      setState((prevState) => ({ ...prevState, answers }));
    },
    [state],
  );

  const renderQuestion = React.useCallback((answers) => {
    return data.question.split('').map((item, index) => {
      const flag = state.randomIndex.includes(index);
      const value = answers?.find((x) => x.id === index);
      return (
        <React.Fragment key={index}>
          <span style={{ display: 'inline-block' }}>
            {flag ? <Input disabled value={value?.answer ?? ''} style={{ width: 30, height: 40 }} maxLength={1} className='input-fill text-center' onChange={(e) => onHandleInput(e.target.value, index)} /> : <span style={{ marginRight: 10 }}>{item}</span>}
          </span>
        </React.Fragment>
      );
    });
  }, [data.question, onHandleInput, state.randomIndex]);

  return (
    <Card className="m-0">
      <CardHeader>
        <QuestionHeader title={data.title} subTitle={data.subTitle} questionIndex={questionIndex} tooltip='FillLetterInTheBlank' />
      </CardHeader>
      <CardBody style={{ minHeight: 300 }}>
        {data.audioUrl && (
          <div className='mb-4'>
            <Button color='warning' onClick={() => playAudio(data.audioUrl)}>
              <i className='fas fa-play' />
              &nbsp;&nbsp;Click to listen
            </Button>
          </div>
        )}
        <div className='questionText'>{renderQuestion(state.answers)}</div>
      </CardBody>
      {ExplainText}
      <CardFooter>
        <h3>Đáp án đúng</h3>
        <div className='questionText'>{renderQuestion(state.correctAnswers)}</div>
      </CardFooter>
    </Card>
  );
};

export default FillLetterInTheBlank;
